// api.js
import axios from 'axios';

const API = axios.create({
    // baseURL: 'http://127.0.0.1:8000/api/', // Replace with your Django backend URL
    baseURL: 'https://bonobohope-chazselph.pythonanywhere.com/api/', // Replace with your Django backend URL
});

// Attach Authorization token if available
API.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken'); // JWT token stored in localStorage
    console.log('Token:', token); // Log the token for debugging purposes
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default API;
